import { Box, Typography, Stack } from "@mui/material";
import { MdSchedule } from "react-icons/md";

const ScheduledInfo = ({ data }) => {
  // Format scheduledDate to IST AM/PM

  const formattedDate = new Date(data.scheduledDate).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        backgroundColor: "background.paper",
        boxShadow: 1,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <MdSchedule size={24} color="#1976d2" />
        <Typography variant="body1">
          This Campaign is scheduled for <strong>{data.totalContacts}</strong>{" "}
          contacts on <strong>{formattedDate}</strong>.
        </Typography>
      </Stack>
    </Box>
  );
};

export default ScheduledInfo;
